import React from "react";
import {
  Table,
  TableCell,
  TableRow,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  PageLoading,
  PageHeadingArea,
  PageTitle,
  PanelDialog,
  PanelHeading,
} from "@backslashbuild/pp-ui";
import { isTextNullOrEmpty } from "./utils";
import { useGetItems } from "./api";
import ContractTypeForm from "./ContractTypeForm";

function ContractTypesTable() {
  const { data, loading, error, queryId } = useGetItems("contract-types");
  const [editTrigger, setEditTrigger] = React.useState(null);

  if (loading || !data) return <PageLoading />;
  if (!isTextNullOrEmpty(error)) return <div>{String(error)}</div>;
  if (!data.isSuccess) return data.errors.map((error) => <div>{error}</div>);

  return (
    <>
      <PageHeadingArea>
        <PageTitle>Contracts</PageTitle>
      </PageHeadingArea>
      <div style={{ height: 400 }}>
        <Table standardTable>
          <TableHeader>
            <TableHeaderColumn width="20%">Contract</TableHeaderColumn>
            <TableHeaderColumn>Template Name</TableHeaderColumn>
          </TableHeader>
          <TableBody fullPageTable={false} footerHeight={0}>
            {data.value.items.map((trigger) => (
              <TableRow onClick={() => setEditTrigger(trigger?.name)}>
                <TableCell width="20%">{trigger?.name}</TableCell>
                <TableCell>{trigger?.template?.name}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
      <PanelDialog open={editTrigger}>
        <PanelHeading>Assign Contract Template</PanelHeading>
        <ContractTypeForm name={editTrigger} onClose={() => setEditTrigger(null)} />
      </PanelDialog>
    </>
  );
}

export default ContractTypesTable;
